module.exports = __webpack_public_path__ + "img/head_img.253c7dc5.png";